<template>
  <div>
<baseFrame
 :submitText='able?"提交":""'
      @submit='handleSubmit'
      @hanldeLog='handleLog'
      @clear="clearAll"
  :logData="logData"
  logText="操作日志"
>
<div slot="content">
<lk-card>
  <lk-tabs type="card" ref='tabs' v-model='tabName'>
    <lk-tab-pane label='基本信息' name='baseInfo'>
      <patientBaseInfo ref="baseInfo" v-model='info.base' :id="id" :able='able'></patientBaseInfo>
    </lk-tab-pane>
    <lk-tab-pane label='用药信息' name='medicineInfo'>
      <medicineInfo ref="medicineInfo" v-model='info.medicineInfo' :id="id" :able='able'>
      </medicineInfo>
    </lk-tab-pane>
  </lk-tabs>
</lk-card>

</div>
</baseFrame>
  </div>
</template>

<script>
import baseFrame from '../../../components/frame/BaseFrame.vue';
import patientBaseInfo from '../../../components/patient/baseInfo.vue';
import medicineInfo from '../../../components/patient/medicineInfo.vue';
import base from '../../../services/base';
import sale from '../../../services/sale';
import utils from '../../../libs/utils';
// import diseaseInfo from '../../../components/patient/diseaseInfo.vue';
// import medServiceInfo from '../../../components/patient/medServiceInfo.vue';
// import otherInfo from '../../../components/patient/otherInfo.vue';

export default {
  name: 'paientInfo',
  components: {
    baseFrame, patientBaseInfo, medicineInfo, // diseaseInfo,  medServiceInfo, otherInfo,
  },
  data() {
    return {
      tabName: '',
      logData: [],
      id: null,
      able: false,
      info: {
        base: {},
      },
    };
  },
  methods: {
    handleLog() {
      this.logData = [];
      sale.getEditLog({
        bizType: 3,
        bizId: this.id,
      }).then((res) => {
        if (res.data.status === 200) {
          this.logData = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    async handleSubmit(again) {
      const patientRebuyList = await this.$refs.medicineInfo.submitData();
      // console.log(patientRebuyList);
      // console.log(this.$refs.baseInfo);
      this.$refs.baseInfo.submitData().then((data) => {
        if (data) {
          const baseInfo = data;
          baseInfo.patientRebuyList = patientRebuyList;
          base.patient.editPatient(baseInfo).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('提交成功');
              this.$router.push({
                name: 'patientList',
              });
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        } else if (!again) {
          this.handleSubmit(true);// 连续调用解决生日验证问题
        } else {
          this.$Message.error('基本信息有误，请按照要求填写');
        }
      }).catch((err) => {
        throw err;
      });
    },

    clearAll() {
      this.$refs.baseInfo.clearAll();
      this.$refs.medicineInfo.getPatientSaleInfo(this.id);
    },

  },
  created() {
    this.id = this.$route.params.id;
    if (this.$route.name === 'patientEdit') {
      this.able = true;
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.msgType === '1') {
      this.tabName = 'medicineInfo';
    }
  },
};
</script>

<style lang="less" scoped>

</style>
